import { useMutation } from '@tanstack/react-query'
import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

import { routeApi } from '../constants'

export const useDelete = (id: number, setNotDirty: () => void) => {
  const navigate = routeApi.useNavigate()
  const { mutateAsync: deleteSAR } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.sar, opts),
    onSuccess: async () => {
      setNotDirty()
      setTimeout(() => navigate({ to: routes.bank.bsa.sar.index }), 0)
    },
    onError: (e) => handlerServerError(e)
  })

  const { open: startDeletion, Confirmation: DeleteConfirmation } = useConfirmation({
    message: `Are you sure you want to delete SAR?`,
    onConfirm: () => deleteSAR({ id }),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return {
    startDeletion,
    DeleteConfirmation
  }
}
